import React, { useState } from 'react';

import { LockOutlined } from '@ant-design/icons';

import { RibbonButton } from 'common/components';
import ProductPackagingModal from '../../modal/product-packaging/ProductPackagingModal';

import Messages from 'i18n/messages/home';
import { useCheckQaSpecLocked } from 'pages/qa-spec/hooks/useCheckQaSpecLocked';

const ProductPackaging = ({ productFull }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const closeModal = () => {
    setModalVisible(false);
  };

  const onClick = () => {
    setModalVisible(true);
  };

  return (
    <>
      <RibbonButton
        icon={<i className='fa-solid fa-box-open'></i>}
        label={Messages.productPackaging}
        onClick={onClick}
      />
      <ProductPackagingModal
        visible={modalVisible}
        closeModal={closeModal}
        productFull={productFull}
      />
    </>
  );
};

export default ProductPackaging;
